import "./style.scss";
import OliverLeftSidebar from "../OliverLeftSidebar";
import OliverRightSidebar from "../OliverRightSidebar";
import OliverBuildFrame from "../OliverBuildFrame";
import { useAppSelector } from "@builder/store/store";
import { useRestartOnboard } from "../SecretDevStuff/useRestartOnboard";

const OliverMain: React.FC = () => {
    const sidebars = useAppSelector(state => state.sidebar);
    useRestartOnboard();

    return (
        <div className="oliver-main">
            {sidebars.leftSidebar.isOpen && <OliverLeftSidebar />}
            <OliverBuildFrame />
            <OliverRightSidebar />
        </div>
    );
};

export default OliverMain;
